(function () {
  'use strict';

  angular.module('app').component('taxDetail', taxDetail());

  function taxDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        taxTypes: '<',
        onTaxSaved: '&',
        onTaxCanceled: '&',
      },
      controller: TaxDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/taxes/tax-detail/tax-detail.component.html',
    };
  }

  TaxDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'moment',
    'SessionService',
    'AbilityService',
    'TaxService',

    // Angular downgraded service
    'companyService',
    'currencyService',
  ];

  function TaxDetailComponent(
    config,
    UtilService,
    moment,
    SessionService,
    AbilityService,
    TaxService,

    // Angular downgraded service
    companyService,
    currencyService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canUpdate: AbilityService.can('update_tax_accountadmin'),
      canDestroy: AbilityService.can('destroy_tax_accountadmin'),
    };

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.computationTypes = config.COMPUTATION_TYPES;
    vm.scopeTypes = config.SCOPE_TYPES;

    // private properties
    let userLanguageCode = SessionService.getUserLanguage().code;

    var dateFormatDB = config.DATE_FORMAT_DB;

    // public methods
    // -----------------------

    vm.$onInit = function () {
      vm.editingTaxRate = false;
      vm.isUndefinedDate = false;

      vm.atvCrEnabled = SessionService.getSelectedAccountCompany().atv_cr_enabled;

      if (vm.item.id) {
        // Edit
        if (!vm.item.tax_rates) {
          vm.item.tax_rates = [];
        }

        vm.item.tax_rates.forEach(function (taxRate) {
          taxRate.from = moment(taxRate.from);
          taxRate.to = moment(taxRate.to);
        });

        setItemOptions(vm.item, vm.mode);
      } else {
        // New
        vm.createMode = true;

        vm.item.tax_rates = [];
      }

      getCompany();
    };

    vm.selectTaxType = function (taxType) {
      vm.blockValue = false;
      vm.item.computation_type = vm.computationTypes.find(
        (computationType) => computationType.value === 'percentage'
      ).value;

      // 01 = Value Added Tax  /  07 = VAT (special calculation) // TODO: why this codes ??
      if (vm.atvCrEnabled && (taxType.code === '01' || taxType.code === '07')) {
        vm.blockValue = true;
      }
    };

    vm.selectTaxRateCode = function (taxRateCode) {
      vm.taxRateCode = taxRateCode;

      vm.item.value = taxRateCode.value;
    };

    vm.selectComputationType = function (computationType) {
      vm.item.value = null;
      vm.item.currency_id = null;

      if (computationType.value === 'fixed') {
        let companyBaseCurrency = vm.currenciesPerCompany.find(
          (currency) => currency.id === vm.companyBaseCurrencyId
        );

        vm.item.currency = companyBaseCurrency;
        vm.item.currency_id = companyBaseCurrency.id;
      }
    };

    vm.addNewDateRate = function () {
      vm.editingTaxRate = true;

      let value = 0;

      if (vm.atvCrEnabled && vm.blockValue) {
        value = vm.item.value;
      }

      let taxRate = {
        value: value,
        from: moment(),
        to: '',
        is_undefined_date: false,
        editMode: true,
        dateToOptions: null,
      };

      vm.item.tax_rates.push(taxRate);

      setTaxRateDatePicker(taxRate);

      if (vm.item.tax_rates.length > 1) {
        let index = vm.item.tax_rates.length - 2; // Select before-last tax rate index

        let minDate = angular.copy(vm.item.tax_rates[index].to).add(1, 'days');

        taxRate.from = minDate;
        taxRate.dateToOptions.minDate = minDate;
      }
    };

    vm.editRate = function (taxRate, index) {
      vm.editingTaxRate = true;

      taxRate.editMode = true;

      setTaxRateDatePicker(taxRate);

      let minDate;
      if (index === 0) {
        minDate = taxRate.from ? taxRate.from : moment();
      } else {
        minDate = angular.copy(vm.item.tax_rates[index - 1].to).add(1, 'days');
      }

      taxRate.dateToOptions.minDate = minDate;

      if (index < vm.item.tax_rates.length - 1) {
        let maxDate = angular.copy(vm.item.tax_rates[index + 1].from).maxDate.add(-1, 'days');

        taxRate.dateToOptions.maxDate = maxDate;
      }
    };

    vm.removeRate = function (index) {
      vm.item.tax_rates.splice(index, 1);

      vm.editingTaxRate = false;
      vm.isUndefinedDate = false;

      setEditableTaxRates();
    };

    vm.keepRate = function (isFormValid, taxRate) {
      if (isFormValid && vm.item.from !== '') {
        taxRate.editMode = false;
        vm.editingTaxRate = false;

        setEditableTaxRates();
      }
    };

    vm.closeRate = function (taxRate, index) {
      if (taxRate.id) {
        taxRate.editMode = false;
        vm.editingTaxRate = false;
        vm.isUndefinedDate = false;
      } else {
        vm.removeRate(index);
      }
    };

    vm.valueChange = function (taxRate) {
      if (!taxRate.value) {
        taxRate.value = 0;
      }
    };

    vm.editTax = function () {
      vm.editMode = true;
      vm.viewMode = false;

      vm.originalItem = angular.copy(vm.item);
    };

    vm.cancelEdit = function () {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    };

    vm.changeTaxStatus = function (tax) {
      if (!vm.permissions.canUpdate || tax.used_in_transactions) return;

      let successCallback = function () {
        vm.onTaxSaved({ item: 'changed' });
      };

      TaxService.changeTaxStatus(tax, successCallback);
    };

    vm.deleteTax = function (tax) {
      if (!vm.permissions.canDestroy || tax.used_in_transactions) return;

      let successCallback = function () {
        vm.onTaxSaved({ item: 'changed' });
      };

      TaxService.deleteTax(tax, successCallback);
    };

    vm.setUndefinedDate = function (taxRate) {
      taxRate.to = taxRate.is_undefined_date ? moment('9999-12-31') : moment();

      vm.isUndefinedDate = taxRate.is_undefined_date;
    };

    // Create/Update
    vm.saveTax = function (isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      let tax = {
        name: vm.item.name,
        tax_type: vm.item.tax_type,
        computation_type: vm.item.computation_type,
        scope_type: vm.item.scope_type,
        tax_rates: vm.item.tax_rates,
        id: null,
      };

      if (vm.item.id) {
        tax.id = vm.item.id;
      }

      tax.tax_rates.map((tax_rate) => {
        tax_rate.from = moment(tax_rate.from).format(dateFormatDB); // yyyy-mm-dd
        tax_rate.to = moment(tax_rate.to).format(dateFormatDB); // yyyy-mm-dd

        // TODO: willy
        // .startOf('day')
        // to => .endOf('day')
      });

      // console.log(vm.item);
      // console.log(tax);
      // return;

      vm.sendingForm = true;
      TaxService.saveTax(vm.item).then(function (data) {
        let status = data.status;
        let response = data.response;

        if (status) {
          // Success
          if (!vm.editMode) {
            // create
            vm.item = response; // reload item
          }

          setItemOptions(response);

          vm.onTaxSaved({ item: response });
        } else {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
          vm.formErrors = true;
        }

        vm.sendingForm = false;
      });
    };

    vm.cancel = function () {
      vm.onTaxCanceled();
    };

    // private methods
    // -----------------------

    function setTaxRateDatePicker(item) {
      item.dateToOptions = {
        singleDatePicker: true,
        showDropdowns: true,
        minDate: moment(),
        drops: 'up',
        locale: {
          format: vm.dateDisplay,
        },
      };
    }

    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      vm.isUndefinedDate = item.tax_rates[item.tax_rates.length - 1].is_undefined_date;

      if (mode === 'edit') {
        vm.editTax();
      }

      let taxType = vm.taxTypes.find((taxType) => taxType.code === item.tax_type);

      if (taxType) {
        if (taxType.code === '01' || taxType.code === '07') {
          vm.blockValue = true;
        }
      }

      setEditableTaxRates();

      vm.itemName = vm.item.name;

      vm.originalItem = angular.copy(item); // store server data
    }

    function setEditableTaxRates() {
      if (vm.item.tax_rates.length === 0) return;

      // let today = moment();
      let today = moment().startOf('day');

      let i = -1;
      vm.item.tax_rates.forEach(function (taxRate, index) {
        let from = moment(taxRate.from);
        let to = moment(taxRate.to);

        if (today.isBetween(from, to.add(1, 'days')) && index !== vm.item.tax_rates.length - 1) {
          taxRate.editable = false;
          i = index;
        } else {
          taxRate.editable = true;
        }
      });

      if (i >= 0) {
        for (let index = i; index >= 0; index--) {
          let taxRate = vm.item.tax_rates[index];
          taxRate.editable = false;
        }
      }
    }

    function getCompany() {
      vm.loadingCompany = true;
      companyService
        .getCompany(SessionService.getSelectedAccountCompany().id, {
          skip_check_role: true,
          lang: userLanguageCode,
        })
        .subscribe((response) => {
          if (response.country.country_setting) {
            vm.taxTypes = response.country.country_setting.tax_types;
            vm.taxRateCodes = response.country.country_setting.tax_rate_codes.sort((a, b) =>
              a.code > b.code ? 1 : -1
            );
          }

          if (vm.item.id && vm.taxRateCodes.length > 0) {
            vm.taxRateCode = vm.taxRateCodes.find(
              (taxRateCode) => taxRateCode.code === vm.item.tax_rate_code
            );

            if (vm.taxRateCode) {
              vm.item.value = vm.taxRateCode.value;
            }
          }

          getCurrencies(response.currency_ids);

          vm.companyBaseCurrencyId = response.currency_id;

          vm.loadingCompany = false;
        });
    }

    function getCurrencies(companyCurrencyIds) {
      let params = {
        get: 'per_company',
        'currency_ids[]': companyCurrencyIds,
        skip_check_role: true,
      };

      vm.loadingCurrenciesPerCompany = true;
      currencyService.getCurrencies(params).subscribe((response) => {
        vm.currenciesPerCompany = response;

        vm.loadingCurrenciesPerCompany = false;
      });
    }
  }
})();
